<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import { cloneDeep } from "lodash";
import Swal from "sweetalert2";
import AttachmentModal from "@/components/modals/attachment-modal.vue";
import PrintOptions from "@/components/modals/print-options.vue";
import POObligationList from "@/components/widgets/po-obligation-list.vue";
import OrderDetailsModal from "@/components/modals/order-details-modal.vue";

export default {
    page: {
        title: "Request for Obligation",
    },
    components: {
        Layout,
        PageHeader,
        AttachmentModal,
        PrintOptions,
        POObligationList,
        OrderDetailsModal
    },
    data() {
        return {
            title: "Request for Obligation",
            items: [
                {
                    text: "Dashboards",
                    href: "/",
                },
                {
                    text: "Request for Obligation",
                    active: true,
                },
            ],
            submitted: false,
            modalTitle: "",
            availableBusy: false,
            available: [],
            tabIndex: 0,
            singleSelection: true,
            pendingRFP: [],
            postedRFP: [],
            filterPosted: "",
            attWActions: true,
            uploadTitle: null,
            uploadOptions: {
                type: "Purchase Order",
                placement: "left",
                folder: "Procurement",
            },
        };
    },
    created() {
        this.changeCycle(this.$store.state.data.cycle);
    },
    computed: {
        selectedAvailableItems() {
            let items = [];
            this.available.forEach((item) => {
                item.toggleSelected && items.push(item);
            });
            return items;
        },
    },
    methods: {
        changeCycle(cycle) {
            this.getAvailable(cycle, this.$store.state.data.selectedCampus.id);
            this.getPostedRFP(cycle, this.$store.state.data.selectedCampus.id);
        },
        changeCampus(campusId) {
            this.getAvailable(this.$store.state.data.cycle, campusId);
            this.getPostedRFP(this.$store.state.data.cycle, campusId);
        },
        getAvailable(cycle, campusId) {
            this.availableBusy = true;
            this.$store
                .dispatch("rfppo/GetAvailableRfpPo", {cycle, campusId})
                .then((res) => {
                    if(res.data.error){
                        return this.showToast(res.data.errorMessage, 'error');
                    }
                    this.availableBusy = false;
                    res.data.forEach((item) => {
                        item.visible = false;
                        item.searchKey = item.description + " " + item.supplierName + " " + item.poNumber;
                        item.toggleSelected = false;
                        item.poFiles = [];
                        item.viewFile = true;
                        item.fileSearch = "";
                        item.attachmentLoading = true;
                    });
                    this.available = res.data;
                })
                .catch((err) => {
                    console.log(err)
                    let stringErr = err.toString();
                    if (stringErr.includes("Network")) {
                        this.showToast("Network Error!", "error");
                    } else {
                        this.showToast(
                            "Something went wrong getting received P.O. list!",
                            "error"
                        );
                    }
                    this.availableBusy = false;
                });
        },
        getPostedRFP(cycle, campusId) {
            this.postedBusy = true;
            this.$store
                .dispatch("rfppo/GetPostedRfpPo", {cycle, campusId})
                .then((res) => {
                    this.postedBusy = false;
                    if(res.data.error){
                        return this.showToast(res.data.errorMessage, 'error');
                    }
                    res.data.forEach((item) => {
                        item.visible = false;
                        item.searchKey = item.poDescription + " " + item.supplier + " " + item.poNumber + " " + item.particulars + " " + item.rfpNumber;
                        item.toggleSelected = false;
                        item.poFiles = [];
                        item.viewFile = true;
                        item.fileSearch = "";
                        item.attachmentLoading = true;
                    });
                    this.postedRFP = res.data;
                })
                .catch((err) => {
                    let stringErr = err.toString();
                    if (stringErr.includes("Network")) {
                        this.showToast("Network Error!", "error");
                    } else {
                        this.showToast(
                            "Something went wrong getting received P.O. list!",
                            "error"
                        );
                    }
                    this.postedBusy = false;
                });
        },
        requestRFP(item) {
            this.modalTitle = "Request for Obligation";
            this.selectedItems = cloneDeep(item);
            this.$refs.ordModalRef.onReset(item);
            this.$bvModal.show("order-details-modal");
        },
        toggleSelectionMode() {
            this.singleSelection = !this.singleSelection;
            this.available.forEach((item) => {
                item.toggleSelected = false;
            });
        },
        updateRequest(item){
            this.modalTitle = "Update Request for Obligation";
            this.selectedItems = cloneDeep(item);
            this.rfp.id = item.id;
            this.rfp.particulars = item.particulars;
            this.rfp.rfpDate = new Date(item.rfpDate);
            this.$bvModal.show("order-details-modal");
        },
        async onCreateRFP(modalData) {
            var data = cloneDeep(modalData);
            data.payee = this.selectedItems.supplierName || this.selectedItems.payee;
            data.supplierId = this.selectedItems.supplierId;
            data.poId = this.selectedItems.id;
            data.cycle =  this.$store.state.data.cycle;
            data.campusId = this.$store.state.data.selectedCampus.id;
            if(data.id > 0){
                await this.$store
                    .dispatch("rfppo/UpdateRfpPo", data)
                    .then((res) => {
                        if (res.data.error) {
                            return this.showToast(res.data.errorMessage, "error");
                        }
                        let index = this.postedRFP.findIndex((i) => i.id == this.selectedItems.id);
                        this.postedRFP.splice(index, 1, res.data);
                        this.$bvModal.hide("order-details-modal");
                        this.showToast('Successfully updated', 'success')
                    })
                    .catch((err) => {
                        let stringErr = err.toString();
                        if (stringErr.includes("Network")) this.showToast("Network Error!", "error");
                        else this.showToast("Something went wrong requesting!", "error");
                    });
            }else{
                var sum = 0;
                this.selectedItems.poItems.forEach((item) => {
                    sum += item.total
                });
                Swal.fire({
                    title: "Are you sure?",
                    text: "You want to request this?",
                    icon: "warning",
                    showCancelButton: true,
                    confirmButtonColor: "#34c38f",
                    cancelButtonColor: "#f46a6a",
                    confirmButtonText: "Yes, request it!",
                }).then(async (result) => {
                    if (result.value) {
                        await this.$store
                            .dispatch("rfppo/CreateRfpPo", data)
                            .then((res) => {
                                if (res.data.error) {
                                    return this.showToast(res.data.errorMessage, "error");
                                }
                                let index = this.available.findIndex((i) => i.id == this.selectedItems.id);
                                this.available.splice(index, 1);
                                this.$bvModal.hide("order-details-modal");
                                res.data.amount = sum;
                                res.data.filterKey = res.data.rfpNumber + " " + res.data.poDescription + " " + res.data.payee + " " + res.data.particulars;
                                let createdPO = cloneDeep(res.data);
                                this.postedRFP.push(createdPO);
                                this.showToast('Successfully requested', 'success')
                            })
                            .catch((err) => {
                                let stringErr = err.toString();
                                if (stringErr.includes("Network")) this.showToast("Network Error!", "error");
                                else this.showToast("Something went wrong requesting!", "error");
                            });
                    }
                })
            }
        },
        deleteRFP(row) {
            var index = this.pendingRFP.indexOf(row);
            let po = row.rfpPoItems.po;
            po.rfqSupplier.supplier = {
                name: row.payee,
                id: row.rfpPoItems.po.rfqSupplierId,
            };
            po.total = row.amount;
            Swal.fire({
                title: "Are you sure?",
                text: "You want to remove this?",
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#dc3545",
                cancelButtonColor: "#5c636a",
                confirmButtonText: "Yes, delete it!",
            }).then(async (result) => {
                if (result.value) {
                    this.$store
                        .dispatch("rfppo/DeleteRfpPo", row.id)
                        .then((res) => {
                            if (res.status == 204) {
                                this.available.push(po);
                                this.pendingRFP.splice(index, 1);
                                this.showToast(
                                    "Successfully deleted",
                                    "success"
                                );
                            }
                        })
                        .catch((err) => {
                            this.showToast("Cannot be deleted", "error");
                        });
                }
            });
        },
        postRFP(row) {
            var index = this.pendingRFP.indexOf(row);
            Swal.fire({
                title: "Are you sure?",
                text: "You want to post this?",
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#34c38f",
                cancelButtonColor: "#f46a6a",
                confirmButtonText: "Yes, post it!",
            }).then((result) => {
                if (result.value) {
                    this.$store
                        .dispatch("rfppayment/postPayment", row.id)
                        .then((res) => {
                            if (res.data.error) {
                                return this.showToast(
                                    res.data.errorMessage,
                                    "error"
                                );
                            }
                            this.pendingRFP.splice(index, 1);
                            this.showToast("Successfully posted", "success");
                            this.postedRFP.push(row);
                        })
                        .catch((err) => {
                            this.showToast("Cannot be posted", "error");
                        });
                }
            });
        },
        poAttachments(id){
            this.uploadTitle = `RFP P.O Attachments`;
            this.$refs.attachmentModal.setUploadOpt({
                type: `RFP P.O`,
                placement: "left",
                folder: "Procurement",
            });
            this.$refs.attachmentModal.getData(id);
            this.$bvModal.show("upload-attachment-modal");
        },
        async getAttachments(row) {
            row.viewFile = true;
            row.poFiles = [];
            row.fileSearch = "";
            row.attachmentLoading = true;
            await this.getFiles(row);
        },
        async getFiles(row){
            await this.$store
                .dispatch("filemanager/GetFiles", {
                    id: row.id,
                    type: this.uploadOptions.type,
                    removeLoading: true,
                })
                .then((res) => {
                    row.attachmentLoading = false;
                    row.poFiles = res.data;
                })
                .catch(() => {
                    row.attachmentLoading = false;
                    this.showToast(
                        "Something went wrong! - getting documents",
                        "error"
                    );
                });
        },
        async printPO(id) {
            this.$refs.printOpt.putOptions({
                apiUrl: "api/Report/Procurement/PO",
                routeVariables: [id],
            });
            this.$bvModal.show("print-options-modal");
        },
    },
};
</script>
<template>
    <Layout @changeCycle="changeCycle" @changeCampus="changeCampus($event.id)">
        <PageHeader :title="title" :items="items" />
        <b-tabs
            content-class="pt-3 pb-3 text-muted"
            v-model="tabIndex"
            nav-class="nav-tabs-custom"
        >
            <b-tab>
                <template v-slot:title>
                    <span class="d-inline-block d-sm-none">
                        <i class="bx bx-home"></i>
                    </span>
                    <span class="d-none d-sm-inline-block">Pending</span>
                </template>
                <POObligationList
                    type="pending"
                    title="Pending P.O to Request for Obligation"
                    subtitle="List of Pending P.O to Request for Obligation"
                    :items="available"
                    :loading="availableBusy"
                    @requestRFP="requestRFP($event)"
                    @printPO="printPO($event)"
                    @getAttachments="getAttachments($event)"
                />
                
            </b-tab>
            <b-tab>
                <template v-slot:title>
                    <span class="d-inline-block d-sm-none">
                        <i class="bx bx-home"></i>
                    </span>
                    <span class="d-none d-sm-inline-block position-relative me-2">Requested</span>
                </template>
                <POObligationList
                    type="requested"
                    title="Requested for Obligation"
                    subtitle="List of requested for Obligation"
                    :items="postedRFP"
                    :loading="postedBusy"
                    @printPO="printPO($event)"
                    @getAttachments="getAttachments($event)"
                />
            </b-tab>
        </b-tabs>
        <div class="position-absolute" style="bottom: 100px; right: 100px">
            <div
                class="position-relative"
                v-if="selectedAvailableItems.length > 0"
            >
                <button
                    class="
                        btn btn-success
                        d-flex
                        align-items-center
                        rounded-pill
                        hover-max-width
                    "
                    type="button"
                    @click="requestRFP(selectedAvailableItems)"
                >
                    <i class="mdi mdi-table-arrow-right font-size-18 me-1"></i
                    ><span>Request for Obligation</span>
                </button>
                <small
                    class="position-absolute badge bg-danger"
                    style="top: -5px; right: -5px; z-index: 10px"
                    >{{ selectedAvailableItems.length }}</small
                >
            </div>
        </div>
        <attachment-modal
            :wActions="attWActions"
            :title="uploadTitle"
            ref="attachmentModal"
        ></attachment-modal>
        
        <print-options ref="printOpt"></print-options>
        <OrderDetailsModal
            ref="ordModalRef"
            :modalTitle="modalTitle"
            @submit="onCreateRFP"
        />
    </Layout>
</template>